import { IonButton, IonIcon, useIonRouter } from '@ionic/react';
import { settingsOutline } from 'ionicons/icons';
import { useQuery } from '@apollo/client/react';
import { GET_FANTASY_LEAGUE_TABS_SHELL } from '../../../graphql/queries/fantasyLeagueTabsShell';
import type {
  GetFantasyLeagueTabsShellQuery,
  GetFantasyLeagueTabsShellQueryVariables,
} from '../../../types/graphql-generated';

interface LeagueSettingsButtonProps {
  leagueId: string;
}

// Gear button shown in the fantasy league tab headers to every member; tapping
// it navigates to the league settings screen.
export const LeagueSettingsButton = ({ leagueId }: LeagueSettingsButtonProps) => {
  const router = useIonRouter();

  // Reads from the Apollo cache (the membership is already loaded by the tabs page),
  // so this does not trigger an extra network request.
  const { data } = useQuery<GetFantasyLeagueTabsShellQuery, GetFantasyLeagueTabsShellQueryVariables>(
    GET_FANTASY_LEAGUE_TABS_SHELL,
    { variables: { fantasyLeagueId: leagueId } }
  );

  if (!data?.currentFantasyLeagueMember) {
    return null;
  }

  return (
    <IonButton
      aria-label="Ajustes de la liga"
      onClick={() => router.push(`/app/ligas/${leagueId}/ajustes`, 'forward', 'push')}
    >
      <IonIcon slot="icon-only" icon={settingsOutline} />
    </IonButton>
  );
};
